// extracted by mini-css-extract-plugin
export default {"layout":"TeamLayout_layout__LNFuI","content":"TeamLayout_content__JhRoN"};